// Class-validator's @IsOptional only skips null/undefined, not "". Empty strings
// reach typed validators (@IsMongoId, @IsEmail, …) and trigger a 400. Strip them
// out of GraphQL payloads so unfilled optional fields are treated as absent.
export function stripEmptyStrings<T extends Record<string, any>>(input: T): Partial<T> {
  const out: Record<string, any> = {}
  for (const [key, value] of Object.entries(input)) {
    if (value === '') continue
    out[key] = value
  }
  return out as Partial<T>
}
